import { memo } from "react";
import { useSelector } from "react-redux";
import { Layout } from "antd";
// import { AblyProvider } from "ably/react";
import { isMenuCollapseSelector } from "appredux/selectors";
// import { createAblyClient } from "utils/ably";
import ContentLayout from "./ContentLayout";

const MainLayout = memo(() => {
  const isMenuCollapsed = useSelector(isMenuCollapseSelector);

  // const albyClient = useMemo(() => {
  //   const client = createAblyClient(selectedCompany?.website_id);
  //   return client;
  // }, [selectedCompany?.website_id]);

  // useEffect(() => {
  //   return () => {
  //     albyClient.close();
  //   };
  // }, [albyClient]);

  return (
    <Layout className="relative flex w-full h-full overflow-hidden" hasSider>
      <ContentLayout isMenuCollapsed={isMenuCollapsed} />
    </Layout>
  );
});

MainLayout.displayName = "MainLayout";

export default MainLayout;
